import styled, { css } from 'styled-components';
import { palette } from 'styled-theme';

export const StyledSelect = styled.div`
  height: 40px;
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  background: ${palette('background', 0)};
  ${(props) =>
    props.notRequireLabel &&
    css`
      border-radius: 4px;
      border: 1px solid ${palette('border', 1)};
    `}
`;

export const StyledOptions = styled.div`
  position: absolute;
  max-height: 180px;
  height: auto;
  overflow-y: auto;
  top: 40px;
  width: 100%;
  padding: 4px 0;
  background: ${palette('background', 0)};
  border: 1px solid ${palette('border', 1)};
  z-index: 1000000000;
`;

export const StyledOption = styled.div`
  padding: 8px 12px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  cursor: pointer;
  color: ${palette('text', 1)};
  &:hover {
    background: ${palette('background', 2)};
    color: ${palette('text', 0)} !important;
  }
  p {
    margin-top: 2px;
    font-size: 13px;
    opacity: 0.7;
  }
`;

export const StyledSelected = styled.div(
  ({ selected, notRequireLabel, customWidth, isRed, isDropDownNotClickable }) => css`
    position: relative;
    width: ${customWidth};
    display: grid;
    grid-template-columns: 1fr 40px;
    ${!notRequireLabel &&
    css`
      ${isRed
        ? css`
            border-bottom: 1px solid #7aeaa7;
          `
        : css`
            border-bottom: 1px solid ${palette('border', 2)};
          `}
    `}

    ${isDropDownNotClickable &&
    css`
      cursor: not-allowed;
      opacity: 0.6;
    `}
   
    &:focus-within {
      ${isRed
        ? css`
            border-bottom: 1px solid #7aeaa7;
          `
        : css`
            border-bottom: 1px solid ${palette('border', 2)};
          `}
    }
    div {
      height: 40px;
      display: flex;
      align-items: center;
      display: grid;
      input {
        height: 39px;
        width: 100%;
        border: none;
        font-size: 14px;
        background: ${palette('background', 0)};
        &:focus {
          outline: none;
        }
      }
      span[data-type='text'] {
        padding-left: 12px;
      }
      span[data-type='icon'] {
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        &:after {
          content: '';
          position: absolute;
          height: 24px;
          width: 24px;
          top: 50%;
          left: 50%;
          border-radius: 50%;
          transform: translate(-50%, -50%);
          display: none;
        }
        ${selected !== null &&
        css`
          &:hover:after {
            display: block;
          }
        `}
      }
    }
    > span {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      &:after {
        content: '';
        position: absolute;
        height: 24px;
        width: 24px;
        top: 50%;
        left: 50%;
        border-radius: 50%;
        transform: translate(-50%, -50%);
        display: none;
      }
      &:hover:after {
        display: block;
      }
    }
  `
);
